import {createStore, applyMiddleware, compose} from 'redux';
import {connectRouter, routerMiddleware} from 'connected-react-router';
import thunk from 'redux-thunk';
import createHistory from 'history/createBrowserHistory';
import {combineReducers} from 'redux';

import app from './app';
import services from './services';
import editorial from './editorial';
import contacts from './contacts';
import products from './products';
import productTypes from './productTypes';

export const history = createHistory();

const enhancers = [];
const middleware = [
    thunk,
    routerMiddleware(history)
];

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV === 'development') {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension());
    }
}

const initialState = {};

const rootReducer = combineReducers({
    router: connectRouter(history),
    app,
    services,
    editorial,
    contacts,
    products,
    productTypes
});

const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
);

const store = createStore(
    rootReducer,
    initialState,
    composedEnhancers
);

export default store;